
export const ActionTypes = {
    TREESELECTEDEMPLOYEE: 'TREESELECTEDEMPLOYEE',
};

export const SetTreeSelectedEmployee = (value) => ({ type: ActionTypes.TREESELECTEDEMPLOYEE, payload: value })

